import { Alert, AlertColor, AlertTitle, SxProps, Theme } from '@mui/material';

interface IAlertMessageProps {
  sx?: SxProps<Theme> | undefined;
  hasIcon?: boolean;
  severity?: AlertColor;
  title?: React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
}

const AlertMessage: React.FunctionComponent<IAlertMessageProps> = ({
  sx,
  title,
  hasIcon,
  severity = 'error',
  children,
}) => (
  <Alert sx={sx} icon={hasIcon} severity={severity}>
    <AlertTitle>{title}</AlertTitle>
    {children}
  </Alert>
);

export default AlertMessage;
